<template>
  <label :for="id" :class="{'inline': inline}">
    <div class="uiRadio" :class="{'checked': model === value}"></div>
    <input for="label" type="radio" :value="value" v-model="model" :name="name" @change="update" :id="id">
    {{label}}
  </label>
</template>

<script>
export default {
  name: 'Radio',
  props: ['label', 'name', 'model', 'value', 'id', 'inline'],
  data () {
    return {
    }
  },
  methods: {
    update () {
      this.$emit('change', this.value)
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/css/style.less";

  label {
    position: relative;
    padding-right: 29px;
    margin-bottom: 0px;
  }

  .inline {
    margin-left: 15px;
  }

.uiRadio {
  border-radius: 50%;
  border:@border;
  width: 15px;
  height: 15px;
  position: absolute;
  right: 0px;
  top: 4px;
  background: @white;
  box-shadow: inset 0px 0px 1px 5px @white;
  transition: all .2s ease-in;
}

.checked {
  border-color: @grey-dark;
  background: @blue-dark;
  box-shadow: inset 0px 0px 0px 0px @white;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/uiRadio.vue